module.exports = __webpack_public_path__ + "static/media/halloween12.44d23f88.webp";